module.exports = __webpack_public_path__ + "static/media/search2.bedb73cb.svg";